import _fetch from './fetch'
const checkLoginStatus = async () => {
  if (window.isLoggedIn) return true
  try {
    const response = await _fetch('/aigc/api/auth/fetchToken')
    const res = await response.json()
    if (res.code === 200) {
      // 埋点userId
      // window.dataLayer && window.dataLayer.push({
      //     'user_id': res.data.userId
      // });
      // window.gtag && window.gtag('event', 'enter_homepage', {
      //     'user_id': res.data.userId
      // });
      window.isLoggedIn = true
      return true
    } else {
      return false
    }
  } catch (error) {
    return false
  }
}

export default checkLoginStatus
